import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import CancelViaBrightbackButton from './brightback/brightback-button';
import { useShouldDirectUserToBrightback } from './brightback/hooks/use-should-direct-user-to-brightback';
import CancelWithinShipStationButton from './cancel-subscription-button';
import { useOnComponentMount } from '../../../../../hooks/use-on-component-mount';
import { getFreeStampsSellerProviders } from '../../../api/subscription';
import { usePaymentAndSubscriptionPageContext } from '../../context/payment-and-subscription-page-context';
import { messages } from '../../messages';

const CancellationEntryPoint = ({ inTrial = false }) => {
  const { setSellerStampsProviders } = usePaymentAndSubscriptionPageContext();

  useOnComponentMount(() => {
    getFreeStampsSellerProviders()
      .then(({ data: arrayOfStampsProviders }) => setSellerStampsProviders(arrayOfStampsProviders))
      .catch(() => setSellerStampsProviders([]));
  });

  const shouldDirectUserToBrightback = useShouldDirectUserToBrightback();

  const cancellationRef = useRef();

  const CancellationButton = shouldDirectUserToBrightback ? CancelViaBrightbackButton : CancelWithinShipStationButton;

  const cancelButtonProps = shouldDirectUserToBrightback ? { key: 'brightback', ref: cancellationRef } : { key: 'native' };

  return (
    <div ref={cancellationRef}>
      <CancellationButton {...cancelButtonProps}>
        <FormattedMessage {...(inTrial ? messages.closeAccount : messages.cancelSubscription)} />
      </CancellationButton>
    </div>
  );
};

CancellationEntryPoint.propTypes = {
  inTrial: PropTypes.bool,
};

export default CancellationEntryPoint;
